class MFRProductTop {
  constructor(i, e) {
    const stickyBar = new MFRProductStickyBar(e);
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      variantSelector: ".variant-selector",
      quantitySelector: ".quantity-selector",
      subscriptionSelector: ".subscription-selector",
      carousel: ".product-top__images-carousel",
      thumbnailsWrapper: ".product-top__thumbs",
      thumbnail: ".product-top__thumb",
      carouselImages: ".product-top__image",
      form: ".product-top__form",
      price: ".product-top__submit .price .money",
      subscriptionPrice:
        '[name="purchase_selector"][value="subscription"] + .subscription-selector__selector .subscription-selector__selector-price',
      oneTimePrice:
        '[name="purchase_selector"][value="one-time"] + .subscription-selector__selector .subscription-selector__selector-price',
      selectorLabel: "[data-label]"
    };

    this.init();
  }

  init() {
    this.$variantSelector = this.$element.find(this.selectors.variantSelector);
    this.$quantitySelector = this.$element.find(
      this.selectors.quantitySelector
    );
    this.$subscriptionSelector = this.$element.find(
      this.selectors.subscriptionSelector
    );
    this.$carousel = this.$element.find(this.selectors.carousel);
    this.$form = this.$element.find(this.selectors.form);
    this.$price = this.$element.find(this.selectors.price);
    this.$selectorLabel = this.$element.find( this.selectors.selectorLabel );

    this.$variantSelector.on(
      "mfr:changed",
      this.__handleVariantChange.bind(this)
    );
    this.$quantitySelector.on(
      "mfr:quantity-changed",
      this.__handleQuantityChange.bind(this)
    );
    this.$subscriptionSelector.on(
      "mfr:subscription-changed",
      this.__handleSubscriptionChange.bind(this)
    );

    this.updatePriceSettings();
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleVariantChange(e, data) {
    if (!this.$quantitySelector.length) return;
    this.$quantitySelector.mfrQuantitySelector("set-quantity", 1);
    this.$quantitySelector.data("max", data.max);
    const discount = this.$subscriptionSelector.length
      ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
      : 0;
      
    this.$selectorLabel.text( data.title );

    this.updatePriceSettings();
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleQuantityChange(e, data) {
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleSubscriptionChange(e, data) {
    this.updatePriceSettings();
    this.updatePrice();
  }

  updateSubscriptionSelectorPrices() {
    if (!this.$subscriptionSelector.length || !this.$quantitySelector.length)
      return;
    const subscription = this.$element.find(this.selectors.subscriptionPrice);
    const onetime = this.$element.find(this.selectors.oneTimePrice);
    const subscriptionPrice =
      this.$form.data("base-price") -
      this.$form.data("base-price") * this.$form.data("price-discount");
    const oneTimePrice = this.$form.data("base-price");

    if (subscription.length)
      subscription.html(
        `${subscription.text()[0]}${this.toFixedIfNecessary(
          subscriptionPrice *
            this.$quantitySelector.mfrQuantitySelector("get-quantity"),
          2
        )}`
      );
    onetime.html(
      `${onetime.text()[0]}${this.toFixedIfNecessary(
        oneTimePrice *
          this.$quantitySelector.mfrQuantitySelector("get-quantity"),
        2
      )}`
    );
  }

  updatePriceSettings() {
    let basePrice, discount;
    if (this.$variantSelector.length)
      basePrice = this.$variantSelector.mfrVariantSelector("get-price");
    discount = this.$subscriptionSelector.length
      ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
      : 0;

    this.$form.data("base-price", basePrice);
    this.$form.data("price-discount", discount);
  }

  updatePrice() {
    if (!this.$price.length || !this.$quantitySelector.length) return;
    const currentPrice =
      (this.$form.data("base-price") -
        this.$form.data("base-price") * this.$form.data("price-discount")) *
      this.$quantitySelector.mfrQuantitySelector("get-quantity");
    this.$price.html(
      `${this.$price.text()[0]}${this.toFixedIfNecessary(currentPrice, 2)}`
    );
  }

  toFixedIfNecessary(value, dp) {
    return +parseFloat(value).toFixed(dp);
  }
}

class MFRProductStickyBar {
  constructor(productTop) {
    this.$element = $(productTop);

    this.selectors = {
      wrapper: ".product-top__sticky-bar",
      inner: ".product-top__sticky-bar-inner",
      activeVariantName:
        ".variant-selector__label input:checked + .variant-selector__label-inner",
      formSubmit: ".product-top__submit button",
      variant: ".product-top__sticky-bar-variant",
      submit: ".product-top__sticky-bar-submit",
      form: ".product-top__form",
    };

    this.data = this.$element.data("sticky-bar-data");
    this.elementsOnBottom = [
      "#admin-bar-iframe",
      ".cc-revoke.cc-bottom.cc-left",
      ".smile-launcher-frame-container",
      ".smile-improved-mobile-launcher",
      "#smile-ui-lite-launcher-frame-container",
      "#gorgias-chat-container #chat-window",
      "#gorgias-chat-container #chat-button",
    ];
    this.init();
  }

  init() {
    this.initStickyBar();

    this.initGSAPAnimation();
  }

  __handleSubmitClick() {
    // $("#offCanvasCart").foundation("open");
    this.$element.find(this.selectors.form).submit();
  }

  initStickyBar() {
    $("body").append(this.generateStickyBar());
    $( "body" )
      .css( "padding-bottom", $( this.selectors.wrapper ).outerHeight() );

    this.$wrapper = $("body").find(this.selectors.wrapper);
    this.$wrapper
      .find(this.selectors.submit)
      .on("click", this.__handleSubmitClick.bind(this));

    gsap.set(this.$wrapper, {
      yPercent: 100,
    });
  }

  generateStickyBar() {
    const className = this.selectors.wrapper.replace(".", "");
    const {
      accentColor,
      darkColor,
      title,
      image,
      ctaLabel,
      ctaUrl,
      freeShippingText,
      smallInfo,
    } = this.data;
    const smallInfoUnEscaped = $("<div/>").html(smallInfo).text();
    const stickyBar = `
            <div class="${className}"
                style="
                    --accent-color: ${accentColor};
                    --dark-color: ${darkColor};
                ">
                <div class="grid-container grid-x">
                    <div class="cell small-12 large-6 ${className}-texts">
                        <div class="${className}-image">
                            <img src="${image}" alt="${title}">
                        </div>
                        <div class="${className}-info">
                            <div class="${className}-title">
                                ${title}
                            </div>
                            ${
                              smallInfoUnEscaped != ""
                                ? `<div class="${className}-small-info">${smallInfoUnEscaped}</div>`
                                : ""
                            }
                        </div>
                    </div>
                    <div class="cell small-12 large-6 ${className}-actions">
                        ${
                          ctaLabel != ""
                            ? `<a href="${ctaUrl}" class="button" role="button"><span>${ctaLabel}</span></a>`
                            : ""
                        }
                        <button class="button ${className}-submit"></button>
                        ${
                          freeShippingText != ""
                            ? `<span class="${className}-free-shipping-text">${freeShippingText}</span>`
                            : ""
                        }
                    </div>
                </div>
            </div>
        `;

    return stickyBar;
  }

  initGSAPAnimation() {
    if (!ScrollTrigger || !ScrollTrigger.create) return;
    if( $( window ).width() <= 1023 )
      this.stickyEnter();
    else
      ScrollTrigger.create({
        trigger: this.$element,
        start: "bottom top",
        endTrigger: "footer",
        end: "top bottom",
        onEnter: () => this.stickyEnter(),
        onEnterBack: () => this.stickyEnter(),
        onLeave: () => this.stickyLeave(),
        onLeaveBack: () => this.stickyLeave(),
      });
  }

  stickyEnter() {
    $("body")
      .find(this.selectors.variant)
      .html(this.$element.find(this.selectors.activeVariantName).html());
    $("body")
      .find(this.selectors.submit)
      .html(this.$element.find(this.selectors.formSubmit).html());

    if (Boolean($("body").find(this.selectors.variant).html()))
      $("body").find(this.selectors.variant).fadeIn();
    else $("body").find(this.selectors.variant).fadeOut();

    gsap.to(this.$wrapper, {
      yPercent: 0,
    });

    this.animateElementsOnBottom(`${this.$wrapper.outerHeight() + 16}px`);
  }

  stickyLeave() {
    gsap.to(this.$wrapper, {
      yPercent: 100,
    });

    this.animateElementsOnBottom(16);
  }
  animateElementsOnBottom(y) {
    $.each(this.elementsOnBottom, (i, e) => {
      if (!$(e).length) return;
      gsap.set(e, {
        transition: "unset",
        opacity: 1,
      });
      gsap.to(e, {
        bottom: y,
      });
    });
  }
}